import { render, staticRenderFns } from "./recoverPassword.vue?vue&type=template&id=1180d2f3&scoped=true&"
import script from "./recoverPassword.js?vue&type=script&lang=js&"
export * from "./recoverPassword.js?vue&type=script&lang=js&"
import style0 from "./recoverPassword.vue?vue&type=style&index=0&id=1180d2f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1180d2f3",
  null
  
)

export default component.exports